<template>
  <div class="cc-float-card" @click="onClick">
    <img v-if="app.logo" class="app-logo" :src="app.logo" />
    <div v-else class="app-logo empty" />
    <div class="app-content">
      <div class="app-name ellipsis">{{ app.title || '应用名称' }}</div>
      <div class="app-desc ellipsis">
        {{ app.description || '应用文案描述' }}
      </div>
    </div>
    <div class="app-button ellipsis">
      <ButtonComp :content="button" :style="buttonStyle" :download="download" />
    </div>
  </div>
</template>
<script>
import ButtonComp from '../Button'

export default {
  name: 'CcFloatSmallCard',
  components: {
    ButtonComp
  },
  props: {
    app: {
      type: Object,
      default: null
    },
    button: {
      type: Object,
      default: () => {}
    },
    buttonStyle: {
      type: Object,
      default: null
    },
    download: {
      type: Object,
      default: null
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>
